import { PeopleSuggestion } from 'owa-search-service';
import { OR_SEPARATOR } from '../searchConstants';
import { createFormattedStringWithPrefix } from './searchQueryStringHelper';

export default function createPersonaSearchQueryString(
    personaSuggestion: PeopleSuggestion,
    useFromPrefix: boolean
): string {
    const singlePersonaQueries: string[] = [];

    if (personaSuggestion.DisplayName !== null) {
        singlePersonaQueries.push(
            createFormattedStringWithPrefix(personaSuggestion.DisplayName, useFromPrefix)
        );
    }

    if (personaSuggestion.EmailAddresses !== null) {
        personaSuggestion.EmailAddresses.forEach((email: string) => {
            if (email !== personaSuggestion.DisplayName) {
                singlePersonaQueries.push(createFormattedStringWithPrefix(email, useFromPrefix));
            }
        });
    }

    // Joining all the queries with an OR
    return singlePersonaQueries.join(OR_SEPARATOR);
}
